// Dependencies
import styled from "styled-components";

export const VirtualAssistantChatEmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    width: 100%;
`;

export const VirtualAssistantChatEmptyStateTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
`;

export const VirtualAssistantChatEmptyStateTitle = styled.h3`
    font-family: Nunito;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: left;
    color: #25272d;
`;

export const VirtualAssistantChatEmptyStateDescription = styled.p`
    font-family: Nunito Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: #505462;
`;

// export const VirtualAssistantChatEmptyStateMessagesWrapper = styled.div`
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     padding: 12px;
//     gap: 8px;
//     border-radius: 8px;
//     background-color: #fafafc;
// `;

// export const VirtualAssistantChatEmptyStateMessageLabel = styled.p`
//     font-family: Nunito;
//     font-size: 14px;
//     font-weight: 600;
//     line-height: 22px;
//     text-align: left;
//     color: #505462;
// `;

export const VirtualAssistantChatEmptyStateMessageContainer = styled.div`
    background: #ffffff;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ffffff;

    transition: border-color 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        border-color: #e5e5e5;
    }
`;

export const VirtualAssistantChatEmptyStateMessageLabel = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #505462;
`;
